export default "__VITE_ASSET__CTsTIhzf__"